module.exports = __webpack_public_path__ + "static/media/pulseai.logo2.2.f4370a6e.png";